import axios from "axios";
export async function get(url): Promise<unknown> {
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (exception) {
    throw new exception.Error();
  }
}

export async function post(url, requestBody, requestHeaders) {
  const response = await axios.post(url, requestBody, requestHeaders);
  return response;
}
